import * as types from 'store/modules/hrms31e/mutation-types'
import hrms31e from 'api/hrms31e'
import swal from 'sweetalert'
import hrms31eLabels from 'assets/labels/hrms31e'
import { hrms31eColumns } from 'assets/columns/hrms31e'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms31eLabels,
    columns: hrms31eColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      tab3: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      }
    },
    dropdowns: {
      codrespr: {
        en: {},
        th: {}
      },
      codexemp: {
        en: {},
        th: {}
      }
    },
    popupDetail: {},
    currentNumseq: 0,
    indexSelected: {},
    saveButtonDisp: true
  },
  getters: {
    [types.GET_HRMS31E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS31E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS31E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS31E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS31E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS31E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS31E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS31E_DETAIL_SEARCH] (state) {
      return state.detail // use same SET_HRMS31E_DETAIL
    },
    [types.GET_HRMS31E_SAVE_BUTTON_DISP] (state) {
      return state.saveButtonDisp
    },
    [types.GET_HRMS31E_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRMS31E_DETAIL_POPUP] (state) {
      return state.popupDetail
    }
  },
  mutations: {
    [types.SET_HRMS31E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS31E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS31E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].columnsTab3Table1 = configLabel.replaceLabelToColumns(state.columns[keyLang].columnsTab3Table1, labels[keyLang])
        state.columns[keyLang].columnsTab3Table2 = configLabel.replaceLabelToColumns(state.columns[keyLang].columnsTab3Table2, labels[keyLang])
      }
    },
    [types.SET_HRMS31E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS31E_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS31E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS31E_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRMS31E_DETAIL_SEARCH] (state, data) {
      state.detail.tab3 = data // use same SET_HRMS31E_DETAIL
    },
    [types.SET_HRMS31E_SAVE_BUTTON_DISP] (state, saveButtonDisp) {
      state.saveButtonDisp = saveButtonDisp
    },
    [types.SET_HRMS31E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRMS31E_DETAIL_POPUP] (state, popupDetail) {
      state.popupDetail = popupDetail
    }
  },
  actions: {
    [types.TOGGLE_HRMS31E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS31E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS31E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS31E_COLUMNS_LABELS] ({ commit }) {
      hrms31e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS31E_COLUMNS, data.labels)
          commit(types.SET_HRMS31E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS31E_INDEX] ({ commit }, searchParams) {
      hrms31e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS31E_INDEX, data)
        })
        .catch((response) => {
          let index = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS31E_INDEX, index)
          const data = response.response.data
          swal({
            title: '', text: data.response, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS31E_DETAIL] ({ commit }, searchParams) {
      hrms31e.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS31E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS31E_DETAIL_SEARCH] ({ commit }, searchParams) {
      hrms31e.getDetailSearch(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS31E_DETAIL_SEARCH, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS31E_DETAIL_POPUP] ({ commit }, popupParams) {
      hrms31e.getDetailPopup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS31E_DETAIL_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS31E_DROPDOWNS] ({ commit }) {
      hrms31e.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS31E_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS31E_SAVE] ({ commit, dispatch }, { indexSelected, detail, codeval, searchParams, searchDetailParams, setBtnSendMail }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms31e.postSave({ indexSelected, detail, codeval })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              // dispatch(types.RECEIVED_HRMS31E_INDEX, searchParams)
              dispatch(types.RECEIVED_HRMS31E_DETAIL, searchDetailParams)
              setBtnSendMail()
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS31E_CANCEL] ({ commit, dispatch }, cancelParams) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms31e.postCancel(cancelParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              // dispatch(types.RECEIVED_HRMS31E_INDEX, {})
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS31E_DELETE] ({ commit, dispatch }, deleteParams) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmDelete'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms31e.postDelete(deleteParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS31E_DETAIL, deleteParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS31E_SEND_MAIL] ({ commit, dispatch }, sendParams) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmEmail'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms31e.postSendMail(sendParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms31e/index.js